<template>
    <div class="dataRepair" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据导入中">

        <div class="breadcrumb">跑步数据修复
            <el-button class="right_f" type="primary" @click="loadModel">下载模板</el-button>
            <el-upload class="right_f" :action="importUrlAction" :with-credentials='true' :on-success="success"
                :on-error="fail" name="uploadFile" :headers="headers" :before-upload="beforeUpload">
                <el-button type="primary">导入数据</el-button>
            </el-upload>
        </div>
        <div class="search">

            <el-select v-model="rootUnid" filterable clearable placeholder="请选择学校">
                <el-option v-for="item in schools" :value="item.rootUnid" :key="item.rootUnid" :label="item.name">
                </el-option>
            </el-select>

            <el-date-picker v-model="fixDate" type="date" :clearable="false" placeholder="选择日期"></el-date-picker>

            <el-select v-model="status">
                <el-option label="全部" value='-1'></el-option>
                <el-option label="成功" value='1'></el-option>
                <el-option label="失败" value='0'></el-option>
            </el-select>

            <div class="el-input">
                <input type="text" placeholder="请输入手机号" class="el-input__inner" v-model="phone"
                    @keyup.enter="getList"></input>
            </div>

            <el-button type="primary" @click="getList">搜索</el-button>
        </div>

        <div class="datas">
            <el-table :data="list" style="overflow-x: auto;">
                <el-table-column prop="name" label="学生">
                </el-table-column>
                <el-table-column prop="schoolname" label="学校">
                </el-table-column>
                <el-table-column prop="gender" label="性别">
                </el-table-column>
                <el-table-column prop="campusId" label="学号">
                </el-table-column>
                <el-table-column prop="phone" label="手机号">
                </el-table-column>
                <el-table-column prop="fixDate" label="修复日期">
                </el-table-column>
                <el-table-column prop="fixLength" label="修复公里数">
                </el-table-column>
                <el-table-column prop="curValidDis" label="有效公里数">
                </el-table-column>
                <el-table-column label="操作记录" inline-template>
                    <div>
                        <div>{{ row.operatorName }}</div>
                        <div>{{ row.operatorDate }}</div>
                    </div>
                </el-table-column>
                <el-table-column label="状态" inline-template>
                    <div>
                        <span v-if="row.status == '1'">成功</span>
                        <span v-if="row.status == '0'">失败</span>
                    </div>
                </el-table-column>
            </el-table>

            <div class="pagination">
                <el-pagination v-show="this.totalCount > 0" layout="prev, pager, next, jumper" :page-size="10"
                    :current-page="currentPage" :total="totalCount" @current-change="handleCurrentChange">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    data() {
        return {
            list: [],
            schools: [],
            fixDate: new Date(),
            status: "-1",
            phone: "",
            rootUnid: "",
            totalCount: 0,
            currentPage: 1,
            headers: {},
            fullscreenLoading: false,
            importUrlAction: this.$util.domain + "/adminapi/v2/record/importexcel"
        }
    },
    computed: mapState({ user: state => state.user }),
    mounted() {
        this.headers.userId = this.user.userId;
        this.getAllSchool();
    },
    methods: {
        getList() {
            let url = this.$util.domain + "/adminapi/v2/record/show";
            if (!this.fixDate) {
                this.$util.errorMsg('请先选择日期', '提示');
                return;
            }
            this.$http({
                url,
                method: 'GET',
                params: {
                    pageSize: 10,
                    status: this.status,
                    phone: this.phone || "-1",
                    pageIndex: this.currentPage,
                    fixDate: this.fixDate ? new Date(this.fixDate).getTime() : new Date().getTime(),
                    rootUnid: this.rootUnid || "-1"
                }
            }).then((response) => {
                this.list = [];
                let list = response.data.data.list;
                this.totalCount = response.data.data.total;
                if (response.data.error == 10000 && list) {
                    list.forEach(item => {
                        this.list.push({
                            name: item.name,
                            phone: item.phone,
                            status: item.status,
                            campusId: item.campusId,
                            schoolname: item.schoolname,
                            operatorName: item.operatorName,
                            gender: item.gender ? "女" : "男",
                            fixLength: (item.fixLength / 1000).toFixed(2),
                            curValidDis: (item.curValidDis / 1000).toFixed(2),
                            fixDate: new Date(item.fixDate).format("yyyy-MM-dd"),
                            operatorDate: new Date(item.operateDate).format("yyyy.MM.dd hh:mm")
                        })
                    });
                } else {
                    this.$util.errorMsg(response.data.message, '提示');
                }
            })
        },
        //获取所有学校
        getAllSchool(str) {
            let url = this.$util.domain + '/adminapi/v1/basicTools/allSchools';

            this.$http({
                url,
                method: 'GET'
            }).then((response) => {
                if (response.data.error == 10000) {
                    response.data.data.splice(0, 1);
                    this.schools = response.data.data.map(item => {
                        item.rootUnid = item.rootUnid + "";
                        return item;
                    });
                } else {
                    this.$util.errorMsg(response.data.message, '提示');
                }
            })

            this.getList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getList();
        },
        //下载模板..........
        loadModel() {
            location.href = "https://admin.gxapp.iydsj.com/template/importRecordV70210.xlsx";
        },
        //导入成功
        success(response) {
            setTimeout(() => {
                this.fullscreenLoading = false;
                if (response.error !== 10000) {
                    this.$util.errorMsg(response.message);
                } else {
                    this.$util.successMsg("上传成功");
                    this.getList();
                }
            }, 2000);
        },
        //导入失败
        fail(response) {
            this.fullscreenLoading = false;
            if (response.status === 403) {
                this.SIGNOUT();
                location.href = "/#";
            }

            this.$util.errorMsg("上传失败");
        },
        beforeUpload() {
            this.fullscreenLoading = true;
        }
    }
}
</script>

<style>
.dataRepair .el-select {
    display: inline-block;
}

.dataRepair .el-input {
    display: inline-block;
        width: auto;
}

.dataRepair .el-button {
    display: inline-block;
}

.dataRepair .el-button+.el-button {
    margin-left: 0;
}

.search {
    margin-left: 30px;
}

.datas {
    margin-top: 20px;
}

.el-dialog__body p {
    line-height: 38px;
}

.dataRepair .el-upload {
    text-indent: 0;
    width: 90px;
}
</style>


// WEBPACK FOOTER //
// dataRepair.vue?3b39f6cb